import { ThemeMode, ThemeModeConstants } from '@helpers/theme.helper';

export enum LSKeys {
  THEME_MODE = 'THEME_MODE',
  USER_LOGGED_IN = 'USER_LOGGED_IN',
}

export class LocalStorage {
  static get(key: LSKeys): ThemeMode | boolean | undefined {
    if (key === LSKeys.THEME_MODE) {
      const val = localStorage.getItem(key);
      switch (val) {
        case ThemeModeConstants.LIGHT:
          return ThemeModeConstants.LIGHT;
        case ThemeModeConstants.DARK:
          return ThemeModeConstants.DARK;
        default:
          return ThemeModeConstants.SYSTEM;
      }
    } else if (key === LSKeys.USER_LOGGED_IN) {
      const val = localStorage.getItem(key);
      return val === 'true';
    }
  }

  static set(key: LSKeys, value: ThemeMode | boolean): void {
    if (key === LSKeys.THEME_MODE) {
      localStorage.setItem(key, value as ThemeMode);
    } else if (key === LSKeys.USER_LOGGED_IN) {
      localStorage.setItem(key, value ? 'true' : 'false');
    }
  }

  static clear(key: LSKeys): void {
    localStorage.removeItem(key);
  }
}
